import React from 'react'
import './about-page.css'

function About() {
  return (
    <div>
        <div
          className="container-fluid bg-primary py-5 mb-5 hero-header"
          style={{
            background: `linear-gradient(rgba(0, 0, 0, 0.856), rgba(79, 79, 79, 0.801)), url(${process.env.PUBLIC_URL}/assets/img/destination-3.jpg)`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            About Us
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                About
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
        
    <section className="about-unique-section py-5">
      <div className="container">
        <div className="about-unique-card">
          <div className="about-unique-grid">
            <div className="about-unique-media wow fadeInUp" data-wow-delay="0.1s">
              <img src="assets/img/aboutus.jpg" alt="Falcon Destinations team" />
              <div className="about-unique-badges">
                <span><i className="fa fa-check-circle" /> IATA Agent</span>
                <span><i className="fa fa-certificate" /> Govt. Licensed</span>
                <span><i className="fa fa-globe" /> Global Travel Services</span>
              </div>
            </div>

            <div className="about-unique-content wow fadeInUp" data-wow-delay="0.2s">
              <h6 className="text-start text-primary pe-3 about-kicker">About Us</h6>
              <h2 className="about-main-title">Falcon Destinations (Pvt.) Ltd</h2>

              <p>
                Falcon Destinations (Pvt.) Ltd as IATA agent in Karachi-Pakistan. The agency is a part of high profiled group Al-Rahim Group of Companies in Pakistan. Falcon Destinations (Pvt.) Limited is graded as Global Destinations and Travel Management Company in Pakistan. Our aim is to provide quality of Travel Services to its customers worldwide.
              </p>
              <p>
                Falcon Destinations (Pvt.) Limited is licensed from Department of Tourist Services, Govt. of Pakistan and IATA approved agent for travel related services, holiday packages and Destination Management Services. We are proud Members of the Travel Agent's Association of Pakistan (TAAP) and Karachi Chamber of Commerce (KCCI).
              </p>
              <p>
                Over the years, we have earned the confidence and trust of our clients, which continues to grow with time. Our main strength is our dedicated employees who have been with our company right from the inception of our travel business.
              </p>
              <p>
                We look forward to serving high-profile organizations, corporates, pharmaceutical companies, and all travelers with assurance and commitment. Our team is dedicated to being your preferred Destination Ground Arrangement and Travel Management partner.
              </p>

              <div className="about-feature-list">
                <div className="about-feature-item">
                  <i className="fa fa-building" />
                  <span>Trusted by corporates and organizations</span>
                </div>
                <div className="about-feature-item">
                  <i className="fa fa-users" />
                  <span>Dedicated team since inception</span>
                </div>
                <div className="about-feature-item">
                  <i className="fa fa-plane" />
                  <span>End-to-end travel and destination management</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="about-values-section pb-5">
      <div className="container">
        <div className="about-values-head text-center wow fadeInUp" data-wow-delay="0.1s">
          {/* <h6 className="section-title bg-white text-center text-primary px-3">Our Values</h6> */}
          <h2>Mission &amp; Vision</h2>
          <p>Driven by service quality, trust, and long-term customer relationships.</p>
        </div>

        <div className="about-values-grid">
          <article className="value-card mission-card wow fadeInUp" data-wow-delay="0.15s">
            <div className="value-card-icon">
              <i className="fa fa-bullseye" />
            </div>
            <h3>Our Mission</h3>
            <p>
              Falcon Destinations (Pvt.) Ltd. aims to be a nationwide supplier. Always strive to provide and deliver highest quality services, timely responses, convenient routes and competitive rates. We are always professionally and personally at your service. Contact us today to plan a dream holiday that will linger in your memory long after it is over.
            </p>
          </article>

          <article className="value-card vision-card wow fadeInUp" data-wow-delay="0.25s">
            <div className="value-card-icon">
              <i className="fa fa-eye" />
            </div>
            <h3>Our Vision</h3>
            <p>
              To be Pakistan's most trusted and preferred travel agency, recognized for our dedication to customer satisfaction, innovative travel solutions, and unwavering commitment to excellence in the travel industry.
            </p>
          </article>
        </div>
      </div>
    </section>

    </div>
  )
}

export default About